import React from "react";
import { Grid, Segment, Button, Header, Icon } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Grid padded>
      <Grid.Column>
        <Segment placeholder>
          <Header icon>
            <Icon name="search" />
            Oops - we've looked everywhere but couldn't find this.
          </Header>
          <Segment.Inline>
            <Button onClick={() => navigate("/")} primary>
              Go to dashboard
            </Button>
          </Segment.Inline>
        </Segment>
      </Grid.Column>
    </Grid>
  );
};

export default NotFound;
